import { render } from "./recentnfts.vue?vue&type=template&id=dbdd7806"
const script = {}

import exportComponent from "C:\\Users\\adeno\\OneDrive\\Dokumen\\CrossTechno\\vue\\x-marks-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__